import React from 'react';

import styles from './styles/styles.module.scss';

import CardDate from '../CardDate';
import FavoriteButton from '../../shared/FavoriteButton';
import StarRating from '../../shared/StarRating';
import Tag from '../../shared/Tag';
import UserImageLink from '../../shared/UserImageLink';
import { getImgDefaultStyle } from '../CardImage/CardImage';
import { getTrackActivity, getTrackProfilePhotoUrl } from '../../../utils/track_helpers';
import { LanguageSupportUtil } from '../../../utils/language_support_util';
import { ServerCommunicationUtil } from '../../../utils/server_communication_util';
import { StringConstantsMixin } from '../../../application/javascripts/react_components/mixins/shared/string_constants_mixin';

const createReactClass = require('create-react-class');

const TrackDetailsCard = createReactClass({
  getInitialState() {
    return {
      hovered: false,
      forcePhotoId: this.props.forcePhotoId
    };
  },
  componentDidMount() {
    this.subscriptions = [];
    if (this.props.messagingChannel) {
      this.subscriptions.push(this.props.messagingChannel.subscribe('map.default_photo.changed', this.handleMapDefaultPhotoChanged));
    }
  },
  componentWillUnmount() {
    while (this.subscriptions.length) {
      this.subscriptions.pop().unsubscribe();
    }
  },
  componentWillReceiveProps(nextProps) {
    if (nextProps.forcePhotoId && nextProps.forcePhotoId != this.props.forcePhotoId) {
      this.setState({ forcePhotoId: nextProps.forcePhotoId });
    }
  },
  handleMapDefaultPhotoChanged(data) {
    this.setState({ forcePhotoId: data.photo_id });
  },
  renderFavoriteButton() {
    if (this.props.showFavoriteHeart && this.props.handleFavoriteClick) {
      return <FavoriteButton className={styles.favorite} handleFavoriteClick={this.props.handleFavoriteClick} isFavorite={this.props.isFavorite} />;
    }
    return null;
  },
  getPhotoUrl() {
    if (this.state.forcePhotoId) {
      return `/api/alltrails/photos/${this.state.forcePhotoId}/image?size=large&key=${ServerCommunicationUtil.apiKey}`;
    }
    return getTrackProfilePhotoUrl(this.props.track);
  },
  renderEditLink() {
    let editLink;
    if (this.props.showEditLink) {
      const trackUrl = LanguageSupportUtil.wrapUrlSafe(
        `/explore${this.props.track.type === 'map' ? '/map/' : '/recording/'}${this.props.track.slug}`,
        this.props.context.languageRegionCode
      );
      editLink = (
        <a className={`${styles.edit} ${styles.inlineBlock}`} href={`${trackUrl}/edit`}>
          {StringConstantsMixin.strings.EDIT}
        </a>
      );
    }
    return editLink;
  },
  render() {
    const trackPhotoUrl = this.getPhotoUrl(this.props.track);
    const backgroundImage = `linear-gradient(rgba(0, 0, 0, 0.0), rgba(0, 0, 0, 0.7)), url(${trackPhotoUrl})`;
    const imgDefaultStyle = getImgDefaultStyle(this.props.track.name, backgroundImage);

    let userProfilePhoto = null;
    if (this.props.track.user) {
      userProfilePhoto = <UserImageLink className={styles.inlineBlock} context={this.props.context} user={this.props.track.user} />;
    }

    return (
      <div className={styles.card} style={imgDefaultStyle} itemProp="image" content={trackPhotoUrl}>
        {/* static positioined */}
        <div className={styles.content}>
          <h1 className={`${styles.name} xlate-none`} itemProp="name" title={this.props.track.name}>
            {this.props.track.name}
          </h1>
          <div>
            {userProfilePhoto}
            <div className={styles.inlineBlock}>
              <div className={styles.flex}>
                <Tag className={styles.inlineBlock} title={getTrackActivity(this.props.track)} />
                <span className={styles.inlineBlock} itemProp="aggregateRating" itemScope itemType="http://schema.org/AggregateRating">
                  <StarRating config={this.props.track.rating} />
                  <meta itemProp="ratingValue" content={this.props.track.rating == null ? '0' : this.props.track.rating} />
                  <meta itemProp="worstRating" content="0" />
                  <meta itemProp="bestRating" content="5" />
                  <meta itemProp="reviewCount" content="1" />
                </span>
              </div>
              <CardDate
                className={styles.date}
                dateString={this.props.track.created_at}
                locale={this.props.context ? this.props.context.languageRegionCode : 'en-US'}
              />
            </div>
          </div>
        </div>
        {/* absolute positioned */}
        {this.renderEditLink()}
        {this.renderFavoriteButton()}
      </div>
    );
  }
});

export default TrackDetailsCard;
